import React from 'react';
import { Helmet } from 'react-helmet-async';

const CandidateDashboard: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Welcome to Candidate Dashboard - Club Corners</title>
      </Helmet>
      <div className="bg-white rounded-lg shadow-md p-6 sm:p-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
          Welcome to Candidate Dashboard
        </h1>
        <p className="text-gray-600">
          This is your candidate dashboard. Use the sidebar to navigate to different sections.
        </p>
      </div>
    </>
  );
};

export default CandidateDashboard;


